module.exports = __webpack_public_path__ + "4.3.2/img/0zai.81ce25cb.png";